module.exports = __webpack_public_path__ + "d1b41a2c98e33b94ef20059083ad28f4.svg";